export const EditableTaleField = {
  data: () => ({
    editable_id: null
  }),

  methods: {
    start_edit: function(id) {
      this.editable_id = id;
    },

    cancel_edit: function() {
      this.editable_id = null;
    },

    is_edit: function(id) {
      return this.editable_id === id;
    }
  }
};
